import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

/**
 * Deleting a library file takes its whole field mapping with it, and the backend only refuses
 * files that have already been sent. What a single misclick could destroy was therefore exactly
 * the mapped-but-not-yet-sent form somebody just finished drawing rectangles on.
 */
const ConfirmDeleteDialog = ({ request, onCancel, onConfirm }) => (
  <Dialog open={Boolean(request)} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Delete {request?.kind}?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {request?.name} will be deleted{request?.detail ? `. ${request.detail}` : ""}. This cannot
        be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button color="error" variant="contained" onClick={onConfirm}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
